import { db } from './firebase';

export const getUsers = () => db.ref('users').once('value');

export const getUsersRenter = () => db.ref('usersRenter').once('value');

export const removeUserRenter = (userId) => db.ref('usersRenter').child(userId).remove();

export const getRoles = () => db.ref('roles').once('value');

export const doRoleUpdate = (userId, role) => db.ref('roles').child(userId).set(role);

export const doProfileUpdate = (userId, email, firstname, lastname, mobile) => db.ref('users').child(userId).set({
  email,
  firstname,
  lastname,
  mobile,
});



// WEBPACK FOOTER //
// ./src/firebase/db.js